module.exports = __webpack_public_path__ + "img/39.9274f9f9.jpg";